import { cn } from '@/lib/utils';
import { SquareArrowOutUpRight } from 'lucide-react';
import Link from 'next/link';
import { useFormatter } from 'next-intl';
import { useTranslation } from 'next-i18next';
import { imgUrl, proxyImgUrl } from '@/shared/utils';

export default function Card({ data }: { data: any }) {
  const format = useFormatter();
  const dateTime = new Date(data.publish_time);
  const { t } = useTranslation();

  const timeResult = format.dateTime(dateTime, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });

  const isSafe = data.risk === 'LOW';
  return (
    <div className="flex rounded-[12px] bg-white border border-[#D9D9D9] overflow-hidden">
      {data.image_url && (
        <img
          className="w-[132px] h-[174px] object-cover"
          src={imgUrl(proxyImgUrl(data?.image_url), 'mid')}
          width={132}
          height={174}
          alt=""
        />
      )}

      <div className="flex-1 p-5 flex flex-col gap-2">
        <div className="flex items-center text-[#1D2129]/60">
          <span
            className={cn('text-xl mr-2 flex-shrink-0 font-semibold', isSafe ? 'text-[#1B9D42]' : 'text-[#EA373A]')}
          >
            {isSafe ? 'Low' : 'High'}
          </span>
        </div>
        <div className="flex-1 flex items-center">
          <div className="flex-1 line-clamp-3 leading-[22px]">{data.content}</div>
        </div>
        <div className="flex justify-between whitespace-nowrap">
          <div className="text-[#1D2129]/60 overflow-hidden text-ellipsis w-0 flex-1">{timeResult}</div>
          <Link className="flex items-center text-[#1D2129]" href={data.post_url} target="_blank">
            {t('View Post')}
            <SquareArrowOutUpRight className="ml-2" size={14} />
          </Link>
        </div>
      </div>
    </div>
  );
}
